import { z } from 'zod';

import { WeekdaySchema } from '../enums';

/** Идентификаторы — cuid2 (BLUEPRINT 4.4): 24 символа [a-z0-9], первый — буква. */
export const IdSchema = z.string().regex(/^[a-z][a-z0-9]{7,31}$/u, 'Некорректный идентификатор');

export const HHmmSchema = z.string().regex(/^([01]\d|2[0-3]):([0-5]\d)$/, 'Время в формате HH:mm');

export const IsoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Дата в формате YYYY-MM-DD');

/**
 * Самое короткое окно времени (раунд 4, N6): короче самого короткого основного сбора (90 мин —
 * падел, волейбол) состав в него не соберётся, а своё окно «19:00–19:30» принималось.
 */
export const MIN_WINDOW_MIN = 90;

/** Длина окна «HH:mm–HH:mm» в минутах (конец раньше начала — отрицательная). */
export function windowMinutes(from: string, to: string): number {
  const m = (s: string) => Number(s.slice(0, 2)) * 60 + Number(s.slice(3, 5));
  return m(to) - m(from);
}

/** Свободные вечера: дни недели и окно времени. Хранится в `User.availability` и `PoolApplication.availability`. */
export const AvailabilitySchema = z
  .object({
    days: z.array(WeekdaySchema).min(1, 'Выбери хотя бы один день').max(7),
    from: HHmmSchema,
    to: HHmmSchema,
  })
  .refine((a) => a.from < a.to, { message: 'Окно времени: начало раньше конца', path: ['to'] })
  .refine((a) => a.from >= a.to || windowMinutes(a.from, a.to) >= MIN_WINDOW_MIN, {
    message: 'Окно времени — хотя бы полтора часа',
    path: ['to'],
  })
  .transform((a) => ({ ...a, days: [...new Set(a.days)].sort((x, y) => x - y) }));

export type Availability = z.infer<typeof AvailabilitySchema>;

/** Телефон в E.164 (после `requestContact` Telegram отдаёт без «+», нормализуем). */
export const PhoneSchema = z
  .string()
  .trim()
  .transform((s) => (s.startsWith('+') ? s : `+${s}`))
  .pipe(z.string().regex(/^\+[1-9]\d{9,14}$/, 'Телефон в международном формате'));

export const KopecksSchema = z.number().int().nonnegative();
